var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#121212",
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.001,139.135c-9.206,0-16.695,7.489-16.695,16.695s7.489,16.695,16.695,16.695c9.206,0,16.695-7.489,16.695-16.695 S265.207,139.135,256.001,139.135z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.001,38.964c-64.443,0-116.866,52.423-116.866,116.866c0,22.554,6.445,44.445,18.62,63.302l85.019,131.724 c3.076,4.76,8.641,7.173,14.314,7.173c0.022,0,0.055,0,0.087,0c5.695-0.022,11.271-3.412,14.326-8.228l83.28-131.506 c11.837-18.663,18.086-40.26,18.086-62.465C372.866,91.387,320.445,38.964,256.001,38.964z M256.001,205.915 c-27.618,0-50.085-22.467-50.085-50.085s22.467-50.085,50.085-50.085s50.085,22.467,50.085,50.085S283.62,205.915,256.001,205.915 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.134,451.059l-66.78-200.341c-2.272-6.815-8.651-11.413-15.837-11.413h-47.524l-81.286,128.365 c-9.25,14.586-25.499,23.684-42.401,23.749h-0.066h-0.152c-17.445,0-33.281-8.391-42.358-22.445l-83.697-129.67H83.484 c-7.184,0-13.565,4.598-15.837,11.413L0.867,451.059c-3.599,10.821,4.46,21.977,15.837,21.977h478.593 C506.674,473.037,514.734,461.88,511.134,451.059z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.7c9f7e51b4c7baada9ce751376cfd8e2.svg";
export { ForwardRef as ReactComponent };